import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FaIconComponent, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ModalService } from '../modals/modal.service';
import { IconPickerModalComponent } from '../icon-picker-modal/icon-picker-modal.component';

@Component({
  selector: 'icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent]
})
export class IconPickerComponent {
  private library = inject(FaIconLibrary);
  private modalService = inject(ModalService);

  readonly value = model<string>('');

  readonly isUnknown = computed(() => {
    const current = this.value();
    return !!current && !this.library.getIconDefinition('fas', current);
  });

  openPicker(): void {
    this.modalService.customized({ initialState: { model: this.value(), class: 'modal-sm' } }, IconPickerModalComponent)
      .subscribe(selected => {
        if (selected !== false) {
          this.value.set(selected as string);
        }
      });
  }
}
